import { Card, Space, Typography } from "antd";

const styles = {
  height: "30px",
};

const InfoCard = ({
  label = "--",
  info = "--",
  icon,
  text = "--",
  color,
  textColor,
}) => {
  return (
    <>
      <Card className="rounded-2xl bg-white xl:relative hover:drop-shadow">
        <div className="border-solid border-inputFieldGrey rounded-sm p-2">
          <Typography.Title
            className="m-0 !font-normal !text-sm sm:!text-md md:!text-md lg:text-lg"
            level={5}
            style={{ color }}
          >
            {label}
          </Typography.Title>
          <Typography.Title className="!mt-2 !mb-2" level={3}>
            {info}
          </Typography.Title>
          <div className="space-align-block">
            <Space align="center" style={styles}>
              {icon && <img src={icon} style={styles} alt="infocard-img" />}
              <div style={styles}>
                <p
                  className="mock-block text-xs sm:text-xs md:text-xs lg:text-xs"
                  style={{ color: textColor || "#000" }}
                >
                  {" "}
                  {text}
                </p>
              </div>
            </Space>
          </div>
        </div>
      </Card>
    </>
  );
};

export default InfoCard;
